export default {
      id: "icon-lig-tv-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-lig-tv",
      toString: function () {
        return this.url;
      }
    }